<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myapplication.request_appeal.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myapplication.title') }} > </span>
            <span class="middle_loc">{{ application_no }} > </span>
            <span class="back_loc">{{ $t('myapplication.request_appeal.title') }}</span>
        </span>
      </h2>

      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">
          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01 active">
              <h2>{{ $t('myapplication.request_appeal.fields.step_01') }}</h2>
              <p>{{ $t('myapplication.request_appeal.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('myapplication.request_appeal.fields.step_02') }}</h2>
              <p>{{ $t('myapplication.request_appeal.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-row class="">
            <v-col cols="12" class="pt-0">
              <div class="component_6 pa-20">
                <v-row>
                  <v-col cols="12">
                    <div class="input_text_type_basic title_box_type">
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        class="ft-size12 t-indent-110"
                        readonly
                        v-model="application_no"
                      >
                      </v-text-field>
                      <v-card-text class="title_inpt_box text_type">{{ $t('myapplication.request_appeal.fields.application_no') }}</v-card-text>
                    </div>
                  </v-col>
                  <v-col>
                    <v-row class="d-flex">
                      <v-col cols="2" class="d-flex align-center nec_title">
                        {{ $t('myapplication.request_appeal.fields.title') }}
                      </v-col>
                      <v-col cols="10">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          class="ft-size12"
                          readonly
                          :value="$vuetify.rtl ? title_ar : title_en"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex">
                      <v-col cols="2" class="d-flex align-center nec_title">
                        {{ $t('myapplication.request_appeal.fields.applicant') }}
                      </v-col>
                      <v-col cols="10">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          class="ft-size12"
                          readonly
                          :value="$vuetify.rtl ? applicant_name_list_ar : applicant_name_list_en"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>

          <v-layout class="inner_contents mt-30" column>
            <v-flex class="item_box pa-0" style="border-bottom: none;">

              <h2 class="m_title">{{ $t('myapplication.request_appeal.fields.apeal_type') }}</h2>
              <v-row class="mt-15">
                <v-col cols="6">
                  <div class="d-flex">
                    <label class="nec_title align-center align-self-center"><i>*</i> {{ $t('myapplication.request_appeal.fields.apeal_type') }}</label>
                    <v-spacer class="hidden_lr5"></v-spacer>
                    <div class="input_text_type_basic">
                      <v-select
                        placeholder=""
                        dense
                        :items="appeal_type"
                        outlined
                        hide-details
                        clearable
                        class="ft-size12"
                      >
                      </v-select>
                    </div>
                  </div>
                </v-col>
              </v-row>



            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <v-row class="mt-25">
              <v-col cols="12" class="pb-0">
                <h2 class="m_title">{{ $t('myapplication.request_appeal.fields.appeal_documents') }}</h2>
              </v-col>
            </v-row>

            <ValidationObserver ref="observer">
              <v-form v-model="valid">
                <template  v-for="(item, index) in attachDocList">
                  <v-flex class="item_box" :key="index">
                    <h2 class="inner_title"><i v-if="item.ind_required == 'Y'">* </i>{{ $vuetify.rtl ? item.name_ar : item.name_en }}</h2>

                    <div class="d-flex mt-15">
                      <div class="file_inpt wp50" ref="inpArray">
                        <template v-for="(document_file, file_index) in item.document_files">
                          <div class="fileForm" :key="file_index">
                            <ValidationProvider v-slot="{ errors }" :name="$vuetify.rtl ? item.name_ar : item.name_en" :rules="{required: item.ind_required == 'Y' && !document_file.document_file_key}">
                              <v-file-input
                                :accept="fnGetAcceptExts(item.doc_exts)"
                                solo
                                outlined
                                flat
                                dense
                                :placeholder="document_file.document_file_name ? document_file.document_file_name : $t('common.common.no_files_selected')"
                                :prepend-icon="$t('common.common.select_file')"
                                class="login_text_filed"
                                v-model="document_file.file"
                                :error-messages="errors"
                                :append-icon="document_file.document_file_name ? '$clear':''"
                                @click:append="fnInitFileForm(document_file)"
                                clearable
                                @click:clear="fnInitFileForm(document_file)"
                                @change="fnUploadFile(item, document_file)"
                              >
                              </v-file-input>
                            </ValidationProvider>
                            <v-text-field v-model="document_file.document_file_seq" v-show="false"></v-text-field>
                            <v-text-field v-model="document_file.document_file_key" v-show="false"></v-text-field>
                          </div>

                          <div :key="file_index + '_btn'" >
                            <v-spacer class="hidden_lr5"></v-spacer>
                            <div v-if="item.ind_multi_upload == 'Y'">
                              <v-btn
                                color="#333"
                                outlined
                                width="70"
                                height="40"
                                class="ft-size12 text-capitalize lcolor-ddd"
                                @click="fnAddFileForm(item)"
                                v-show="file_index == 0"
                              >
                                {{ $t('appealoppsition.opposition.fields.add_document') }}
                              </v-btn>
                              <v-btn
                                color="#333"
                                outlined
                                width="70"
                                height="40"
                                class="ft-size12 text-capitalize lcolor-ddd"
                                @click="fnDelFileForm(document_file, file_index)"
                                v-show="file_index > 0"
                              >
                                {{ $t('common.button.delete') }}
                              </v-btn>
                            </div>
                          </div>
                        </template>
                        <v-text-field v-model="item.user_document_config_seq" v-show="false"></v-text-field>
                        <v-text-field v-model="item.document_seq" v-show="false"></v-text-field>
                      </div>
                    </div>

                  </v-flex>
                </template>
              </v-form>
            </ValidationObserver>
          </v-layout>

          <v-divider class="mt-25 mb-25"></v-divider>
          <v-row class="ma-0">
            <v-col cols="12" class="d-flex pa-0">
              <v-spacer></v-spacer>
              <v-btn
                dense
                height="50"
                width="150"
                dark
                color="#a01c2a"
                class="capitalize btn_basic br_none"
                @click="fnNext()"
              >
                {{ $t('common.button.next') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>


      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  components :{
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      valid : false,
      seq : '',

      appeal_type : [
        { text : '심사 거절에 대한 Appeal (Notification # 1234)', value : '1234'},
        { text : '심사 거절에 대한 Appeal (Notification # 1235)', value : '1235'},
        { text : '연체료 미납에 대한 Appeal (invoice # 12345)', value : '12345'},
      ],

      application_no : '',
      application_seq : '',
      title_en : '',
      title_ar : '',
      applicant_name_list_ar : '',
      applicant_name_list_en : '',

      receipt_no : '',
      attachDocList : []
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.receipt_no = this.$route.params.receipt_no
    this.fnSearchApplication()
    this.fnGetAttachDocList()
  },
  methods : {

    fnSearchApplication(){

      requestApi({
        url: '/applications/search/'+this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.title_en = res.data.title_en
            this.title_ar = res.data.title_ar
            this.applicant_name_list_ar = res.data.applicant_name_list_ar
            this.applicant_name_list_en = res.data.applicant_name_list_en
            this.application_seq = res.data.application_seq
            this.application_no = res.data.application_no

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSearchApplication()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetAttachDocList(){

      requestApi({
        url: '/receivings/' + this.receipt_no + '/documents',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            let attachDocList = res.data.list

            attachDocList.forEach( item => {
              if(item.document_files.length == 0){
                //넘겨받은 데이터에서 파일 목록이 없을 경우 초기 셋팅을 해야 한다
                let defaultForm = {
                  document_file_seq : '',
                  document_file_key : '',
                  document_file_name : '',
                  file : null
                }
                item.document_files.push(defaultForm)
              }else{
                //넘겨받은 데이터에서 파일 목록이 있을 경우 파일폼만 추가
                item.document_files.forEach( doc_item => {
                  doc_item.file = null
                })
              }
            })

            this.attachDocList = attachDocList

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAttachDocList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              this.error_msg = this.$vuetify.rtl ? res.res_msg_en : res.res_msg_ar
            }
          }
        }
      })
    },

    fnGetAcceptExts(doc_exts){
      let accept = ""

      doc_exts.forEach(item => {
        if(accept.length > 0){
          accept = accept + ","
        }
        accept = accept + "."+item.name_en
      })

      return accept
    },

    fnNext(){

      this.$refs.observer.validate().then((valid) => {
        if(valid){
          let params = []
          let attachDocList = this.attachDocList
          for(let i=0; i<attachDocList.length; i++){

            for(let k=0; k<attachDocList[i].document_files.length; k++){
              let paramItem = {
                user_document_config_seq : attachDocList[i].user_document_config_seq,
                document_seq : attachDocList[i].document_seq,
                document_file_seq : attachDocList[i].document_files[k].document_file_seq,
                document_file_key : attachDocList[i].document_files[k].document_file_key,
                ind_multi_upload: attachDocList[i].ind_multi_upload
              }

              params.push(paramItem)
            }
          }

          requestApi({
            url: '/receivings/appeal/' + this.receipt_no + '/documents',
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                this.$router.push({path : '/myapplication/requestappeal/step2/' + this.$route.params.receipt_no })
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnNext()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  this.error_msg = this.$vuetify.rtl ? res.res_msg_en : res.res_msg_ar
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },


    fnUploadFile(item, documentFile) {
      let fileExts = item.doc_exts
      let uploadFile = documentFile.file
      let specTypeCode = item.spec_type_code
      let langTypeCode = item.lang_type_code

      if(uploadFile != null){
        if (utils.getFileExtLen(uploadFile, fileExts, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            documentFile.file = null
            documentFile.document_file_key = ''
            documentFile.document_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", uploadFile)
        formData.append("spec_type_code", specTypeCode)
        formData.append("lang_type_code", langTypeCode)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            if (res.res_code === '200') {
              documentFile.document_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadFile(item, documentFile)
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                documentFile.file = null
                documentFile.document_file_key = ''
                documentFile.document_file_name = ''
              }
            }
          }
        })
      }
    },

    fnAddFileForm(item){
      let defaultForm = {
        document_file_seq : '',
        document_file_key : '',
        document_file_name : '',
        file : null
      }
      item.document_files.push(defaultForm)
    },

    fnDelFileForm(documentFile, index){
      documentFile.splice(index, 1)
    },

    fnInitFileForm(documentFile) {
      documentFile.document_file_key = ''
      documentFile.document_file_name = ''
      documentFile.file = null
      documentFile.pdf_file_name = ''
      documentFile.pdf_file_path = ''
    },


  }
}
</script>